import { Bracket } from '../components/Bracket.js';
import { PendingInvite } from '../components/PendingInvite.js';
import { useApp } from '../store.js';
import { placeTitle, pluralRu, roundTitle } from '../strings.js';
import { ShareButton } from './ShareButton.js';

const CONFETTI = ['#ffd23f', '#3ddc84', '#5ec8ff', '#ff5a5f', '#ffffff'];

/** Выбыл из турнира (out) или турнир окончен (finish): итог, сетка, сыграть снова. */
export function Finish({ out }: { out?: boolean }) {
  const t = useApp((s) => s.tournament);
  const play = useApp((s) => s.play);
  const joining = useApp((s) => s.joining);
  const share = useApp((s) => s.share);
  const createDuel = useApp((s) => s.createDuel);
  const goHome = useApp((s) => s.goHome);
  const playQuick = useApp((s) => s.playQuick);
  if (!t) return null;
  const you = t.players.find((p) => p.isYou);
  const champion = t.players.find((p) => p.id === t.championId);
  const isChampion = !!you && you.id === t.championId;
  const duel = t.kind === 'DUEL' || t.kind === 'QUICK';
  const quick = t.kind === 'QUICK';
  const opponent = t.players.find((p) => !p.isYou);
  const wins = Math.log2(t.size);

  let title: string;
  let lead: string;
  if (duel) {
    title = quick
      ? isChampion
        ? 'Победа!'
        : 'Поражение'
      : isChampion
        ? 'Дуэль выиграна!'
        : 'Дуэль проиграна';
    lead = opponent ? `Соперник — ${opponent.name}` : '';
  } else if (isChampion) {
    title = t.kind === 'FRIENDS' ? 'Кубок друзей ваш!' : 'Чемпион!';
    lead = `${wins} ${pluralRu(wins, 'победа', 'победы', 'побед')} подряд — кубок ваш`;
  } else {
    title = out ? `Вы выбыли: ${roundTitle(you?.eliminatedIn ?? 1, t.size).toLowerCase()}` : 'Турнир окончен';
    lead = you?.eliminatedIn
      ? `${placeTitle(you.eliminatedIn, t.size)}${champion ? ` · чемпион — ${champion.name}` : ''}`
      : champion
        ? `Чемпион — ${champion.name}`
        : '';
  }

  return (
    <main className={`screen finish ${isChampion ? 'finish--champion' : ''}`}>
      {isChampion && (
        <div className="confetti" aria-hidden="true">
          {Array.from({ length: 28 }, (_, i) => (
            <i
              key={i}
              style={{
                left: `${(i * 37) % 100}%`,
                animationDelay: `${(i % 7) * 0.18}s`,
                background: CONFETTI[i % CONFETTI.length],
              }}
            />
          ))}
        </div>
      )}
      <div className="finish__trophy" aria-hidden="true">
        {duel ? '⚔️' : isChampion ? '🏆' : out ? '🥅' : '🏁'}
      </div>
      <h1 className="screen__title">{title}</h1>
      {lead && <p className="screen__lead">{lead}</p>}
      {t.yourReward ? <p className="match-end__coins">+{t.yourReward} 🪙 за место</p> : null}
      {t.yourGold ? (
        <p className="match-end__coins">
          +{t.yourGold.amount} 🟡 Gold{t.yourGold.claimable ? '' : ' (бонусный — в турнире были боты)'}
        </p>
      ) : null}
      {(t.kind === 'DUEL' || t.kind === 'FRIENDS') && (
        <p className="field__hint">Дружеский матч — без рейтинга и серебра</p>
      )}
      <PendingInvite />
      {isChampion && !duel && (
        <ShareButton
          label="📣 Поделиться кубком"
          onShare={() => share({ kind: 'cup', tournamentId: t.id })}
        />
      )}
      {quick ? (
        <button
          type="button"
          className="play play--small"
          onClick={() => void playQuick()}
          disabled={joining}
        >
          ⚡ Ещё 1 на 1
        </button>
      ) : duel ? (
        <button
          type="button"
          className="play play--small"
          onClick={() => void createDuel()}
          disabled={joining}
        >
          ⚔️ Реванш
        </button>
      ) : (
        <button
          type="button"
          className="play play--small"
          onClick={() => void play(t.size === 4 ? 4 : 8)}
          disabled={joining}
        >
          {joining ? 'Ищем турнир…' : `Ещё турнир на ${t.size}`}
        </button>
      )}
      <button type="button" className="link" onClick={goHome}>
        На главный
      </button>
      {!duel && <Bracket tournament={t} />}
    </main>
  );
}
